package songwritersnotebook.app.components

import androidx.compose.foundation.layout.*
import androidx.compose.material3.*
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Delete
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import kotlinx.coroutines.launch
import songwritersnotebook.app.data.UserProfile

@Composable
fun SessionLimitDialog(
    userProfile: UserProfile?,
    currentDeviceId: String,
    onDismissRequest: () -> Unit,
    onRemoveSession: suspend (String) -> Unit
) {
    val sessions = userProfile?.activeSessions?.values?.toList() ?: emptyList()
    val canDismiss = sessions.size <= 3
    val scope = rememberCoroutineScope()
    var deletingSessionId by remember { mutableStateOf<String?>(null) }
    
    AlertDialog(
        onDismissRequest = { if (canDismiss) onDismissRequest() },
        title = { Text("Session Limit Reached") },
        text = {
            Column(verticalArrangement = Arrangement.spacedBy(12.dp)) {
                Text("You are signed in on ${sessions.size} devices. Please remove an old device to continue using this one (Limit: 3).")
                sessions.forEach { session ->
                    val isCurrent = session.deviceId == currentDeviceId
                    val isDeleting = deletingSessionId == session.deviceId

                    Card(
                        modifier = Modifier.fillMaxWidth(),
                        colors = CardDefaults.cardColors(
                            containerColor = if (isCurrent) MaterialTheme.colorScheme.primaryContainer else MaterialTheme.colorScheme.surfaceVariant
                        )
                    ) {
                        Row(
                            modifier = Modifier.padding(12.dp),
                            verticalAlignment = Alignment.CenterVertically,
                            horizontalArrangement = Arrangement.SpaceBetween
                        ) {
                            Column(modifier = Modifier.weight(1f)) {
                                Text(
                                    text = if (isCurrent) "${session.deviceName} (Current)" else session.deviceName,
                                    style = MaterialTheme.typography.bodyLarge,
                                    fontWeight = FontWeight.Bold
                                )
                                Text(text = session.platform, style = MaterialTheme.typography.bodySmall)
                            }
                            if (!isCurrent) {
                                if (isDeleting) {
                                    CircularProgressIndicator(
                                        modifier = Modifier.size(24.dp),
                                        strokeWidth = 2.dp
                                    )
                                } else {
                                    IconButton(onClick = { 
                                        deletingSessionId = session.deviceId
                                        scope.launch {
                                            onRemoveSession(session.deviceId)
                                            deletingSessionId = null
                                        }
                                    }) {
                                        Icon(Icons.Default.Delete, contentDescription = "Remove Device", tint = MaterialTheme.colorScheme.error)
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        confirmButton = {
            TextButton(
                onClick = { onDismissRequest() },
                enabled = canDismiss
            ) {
                Text("Done")
            }
        }
    )
}
